import WarehouseRentListOverview from './warehouse_rent_list_overview'
import connect from './connect'

export default connect(WarehouseRentListOverview)
